export const Icon = () => {
    return (
        <svg viewBox="0 0 70 60" width="70" height="60" fill="none" stroke="#D4BC87">
            <path
                d="M37.2715 46.4303L45.0103 38.8737C45.3569 38.5353 45.9021 38.4881 46.3043 38.7617L58.3705 46.9724C58.8874 47.3241 58.953 48.0466 58.5075 48.4816L54.2579 52.6312C53.54 53.3322 52.5141 53.6353 51.5331 53.3799C47.2703 52.2697 35.1778 48.4566 25.4635 38.9709C15.7492 29.4853 11.8441 17.6774 10.7072 13.5149C10.4455 12.5571 10.756 11.5553 11.4739 10.8543L15.7235 6.70475C16.169 6.26974 16.9089 6.33376 17.2691 6.83849L25.6777 18.6207C25.958 19.0134 25.9096 19.5458 25.563 19.8842L17.8243 27.4408"
                strokeLinecap="round"
            />
        </svg>
    );
};
